import React, { useEffect } from 'react';
import { SxProps } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import Cookies from 'js-cookie';
import { CookieEnum } from '../../../enums/cookie-enum';
import { useGetMeQuery } from '../../../store/apiSlice/userApi';
import { setAuthData } from '../../../store/apiSlice/auth/authSlice';
import { useDispatch, useSelector } from 'react-redux';
import { selectAuthData } from '../../../store/selectors/authSelector';

type MyAvatarProps = {
  sx?: SxProps;
};

const MyAvatar = ({ sx }: MyAvatarProps) => {
  const dispatch = useDispatch();
  const authData = useSelector(selectAuthData);
  const token = Cookies.get(CookieEnum.ACCESS_TOKEN);

  // Unified /me endpoint for all roles.
  // Always include 'company' so company users get company relation in authData.
  const { data: userData } = useGetMeQuery(['company'], {
    skip: !token,
  });

  // only dispatch when userData actually changes
  useEffect(() => {
    if (userData) {
      dispatch(setAuthData({ user: userData }));
    }
  }, [dispatch, userData]);

  // Direct access to JSONB media structure
  const avatarSource = userData || authData?.user;
  const avatarUrl = avatarSource?.media?.avatar?.fileUrl || '';

  return <Avatar sx={sx} alt="Profile Avatar" src={avatarUrl} />;
};

export default MyAvatar;
